// extracted by mini-css-extract-plugin
module.exports = {"root":"ProtectBlock_root__X0LOw","grid":"ProtectBlock_grid__ZtjaG","rightSection":"ProtectBlock_rightSection__KnpG4","gif":"ProtectBlock_gif__qqlDJ"};